import React, { useEffect, useState } from "react";
import {
  handleAlphabetsWithoutSpaceChange,
  handleError,
  handleNumbersChange,
} from "../../CommonJquery/CommonJquery";
import {
  server_post_data,
  maintainance_car_data,
  upload_image_to_folder,
} from "../../ServiceConnection/serviceconnection";
import { X } from "lucide-react";

const CarInspections = ({
  onNext,
  onBack,
  MaintainanceData,
  setCount,
    BookingData,
  ImageLink,
  cardata,
  ImageLinkIpass,
  FromComeData,
}) => {
  // State hooks for each form field
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [carinspectiondata, setFormData] = useState({
    fenderLiners: "",
    fenderLinersAdjustedPosition: "",
    hasCitySticker: "no",
    citySticker: "",
    city_img: null,
    city_img_name: "",
    heatingAC: "",
    inspectionnote: "",
    resetMaintenance: "",
    odometerReading: "",
    ipassNumbers: "",
    ipass_img: null,
    ipass_img_name: "",
  });
  const [heatingNote, setHeatingNote] = useState("");

  //console.log("heatingNote", cardata);
  // State hooks to manage error messages
  const [errorMessages, setErrorMessages] = useState({
    fenderLiners: "",
    fenderLinersAdjustedPosition: "", // Error for new field
    citySticker: "",
    heatingAC: "",
    resetMaintenance: "",
    odometerReading: "",
    ipassNumbers: "",
    inspectionnote: "",
    city_img: "",
    ipass_img: "",
    heatingNote: "",
  });
  useEffect(() => {
    setFormData({
      fenderLiners: MaintainanceData.fender_liners || "",
      fenderLinersAdjustedPosition:
        MaintainanceData.fender_liners_position || "",
      hasCitySticker: MaintainanceData.has_city_sticker || "no",
      citySticker: MaintainanceData.city_stiker || "",
      city_img_name: MaintainanceData.city_sticker || "",
      heatingAC: MaintainanceData.ac_check || "",
      inspectionnote: MaintainanceData.inspectionnote || "",
      resetMaintenance: MaintainanceData.reset_maintainance || "",
      odometerReading: MaintainanceData.odo_metter || "",
      ipassNumbers: cardata.ipass_number || "",
      ipass_img_name: MaintainanceData.ipass_image || "",
      city_img: null,
      ipass_img: null,
    });

    setHeatingNote(MaintainanceData.ac_note || "");
  }, [MaintainanceData, cardata]);

  const handleSelect = (field, value) => {
    setFormData((prevData) => {
      let updatedData = { ...prevData, [field]: value };

      if (field === "fenderLinersAdjustedPosition") {
        // Split existing string into array
        const currentValues = prevData.fenderLinersAdjustedPosition
          ? prevData.fenderLinersAdjustedPosition.split("~@~")
          : [];

        // Toggle value
        if (currentValues.includes(value)) {
          // Remove it
          updatedData.fenderLinersAdjustedPosition = currentValues
            .filter((item) => item !== value)
            .join("~@~");
        } else {
          // Add it
          updatedData.fenderLinersAdjustedPosition = [
            ...currentValues,
            value,
          ].join("~@~");
        }
      } else {
        updatedData[field] = value;
      }

      // 🧼 Fender Liners: Clear adjusted position if not selected
      if (field === "fenderLiners" && value !== "linersAdjusted") {
        updatedData.fenderLinersAdjustedPosition = "";
        setErrorMessages((prevErrors) => ({
          ...prevErrors,
          fenderLinersAdjustedPosition: "",
        }));
      }

      // 🧼 Has City Sticker: Clear citySticker and city image if "no" is selected
      if (field === "hasCitySticker" && value === "no") {
        updatedData.citySticker = "";
        updatedData.city_img = null;
        updatedData.city_img_name = "";
        setErrorMessages((prevErrors) => ({
          ...prevErrors,
          citySticker: "",
          city_img: "",
        }));
      }

      return updatedData;
    });

    // 🧽 Clear any existing validation error for the changed field
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      [field]: "",
    }));
  };

  const handleCityImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      uploadImageserver(file, 1, 0);
    }
  };

  const handleIpassImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      uploadImageserver(file, 2, 1);
    }
  };

  const uploadImageserver = async (file, flag, status) => {
    const fd = new FormData();
    fd.append("image", file);
    if (status === 1) {
      fd.append("image_tag", "Ipass");
    }
    await server_post_data(upload_image_to_folder, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (flag === 1) {
            setFormData((prevData) => ({
              ...prevData,
              city_img: file, // Store city image
              city_img_name: Response.data.message.image_uploaded, // Store city image
            }));
            setErrorMessages((prevErrors) => ({
              ...prevErrors,
              city_img: "",
            }));
          } else {
            setFormData((prevData) => ({
              ...prevData,
              ipass_img: file,
              ipass_img_name: Response.data.message.image_uploaded,
            }));
            setErrorMessages((prevErrors) => ({
              ...prevErrors,
              ipass_img: "",
            }));
          }
        }
      })
      .catch(() => {});
  };

  const removeCityImage = () => {
    setFormData((prevData) => ({
      ...prevData,
      city_img: null,
      city_img_name: "",
    }));
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      city_img: "",
    }));
    document.getElementById("imageInput_city").value = "";
  };

  const removeIpassImage = () => {
    setFormData((prevData) => ({
      ...prevData,
      ipass_img: null,
      ipass_img_name: "",
    }));
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      ipass_img: "",
    }));
    document.getElementById("imageInput_ipass").value = "";
  };
  //console.log("carinspectiondata", carinspectiondata);
  const handleNext = async () => {
    let errors = {};
    let validationPassed = true; // For debugging

    // 1️⃣ General required fields validation
    // for (const key in carinspectiondata) {
    //   if (
    //     key !== "fenderLinersAdjustedPosition" &&
    //     key !== "citySticker" &&
    //     (carinspectiondata[key] === "" || carinspectiondata[key] === null)
    //   ) {
    //     errors[key] = "Please fill this field";
    //   }
    // }

    // 2️⃣ City sticker + image validation (if "yes")
    if (carinspectiondata.hasCitySticker === "yes") {
      if (!carinspectiondata.citySticker) {
        errors.citySticker = "Please select a city sticker";
      }
      if (
        !carinspectiondata.city_img &&
        carinspectiondata.city_img_name === ""
      ) {
        errors.city_img = "Please upload a city image";
      }
    }

    // 3️⃣ Liner validation
    if (
      !carinspectiondata.fenderLiners &&
      carinspectiondata.fenderLiners === ""
    ) {
      errors.fenderLiners = "Please select liners ";
    }

    if (
      !carinspectiondata.resetMaintenance &&
      carinspectiondata.resetMaintenance === ""
    ) {
      errors.resetMaintenance = "Please select this field ";
    }
    // if (!carinspectiondata.odometerReading && carinspectiondata.odometerReading === "") {
    //   errors.odometerReading = "Please enter Odometer Reading ";
    // }

    // 3️⃣ I-Pass image validation
    if (
      !carinspectiondata.ipass_img &&
      carinspectiondata.ipass_img_name === ""
    ) {
      errors.ipass_img = "Please upload an ipass image";
    }

    // 4️⃣ Fender liners adjusted position (if applicable)
    if (
      carinspectiondata.fenderLiners === "linersAdjusted" &&
      !carinspectiondata.fenderLinersAdjustedPosition
    ) {
      errors.fenderLinersAdjustedPosition =
        "Please select adjusted liners position";
    }

    // 5️⃣ Heating/AC Check: note is required if "Need Attention"
    if (!carinspectiondata.heatingAC) {
      errors.heatingAC = "Please select Heating & AC status";
    } else if (
      carinspectiondata.heatingAC === "needAttention" &&
      (!heatingNote || heatingNote.trim() === "")
    ) {
      errors.heatingNote = "Please provide a note for AC issue";
    }

    // 🔄 Set errors for display
    setErrorMessages(errors);
    // console.log(errors);

    // ✅ Logging validation result
    if (Object.keys(errors).length === 0) {
      //console.log("✅ Validation Passed");
      validationPassed = true;
    } else {
      //console.log("❌ Validation Failed:", errors);
      validationPassed = false;
    }

    // 🚀 Proceed only if valid
    if (validationPassed) {
      setshowLoaderAdmin(true);

      const fd = new FormData();
      fd.append("car_id", cardata.primary_id);
        fd.append("booking_id", cardata.current_booking_id);
      fd.append("user_id", BookingData?.user_id || 0);
      fd.append("fender_liners", carinspectiondata.fenderLiners);

      if (carinspectiondata.fenderLiners === "linersAdjusted") {
        fd.append(
          "fender_liners_position",
          carinspectiondata.fenderLinersAdjustedPosition
        );
      } else {
        fd.append("fender_liners_position", "");
      }

      fd.append(
        "ac_check",
        carinspectiondata.heatingAC === "needAttention"
          ? heatingNote
          : carinspectiondata.heatingAC
      );
      fd.append("reset_maintainance", carinspectiondata.resetMaintenance);
      fd.append("ipass_image", carinspectiondata.ipass_img_name);
      // fd.append("odo_metter", carinspectiondata.odometerReading);
      fd.append("last_5_digit_ipass", carinspectiondata.ipassNumbers);
      fd.append("has_city_sticker", carinspectiondata.hasCitySticker);
      fd.append("edit_or_new", MaintainanceData?.primary_id || 0);
      fd.append("save_or_edit_type", FromComeData);
      fd.append("city_sticker_image", carinspectiondata.city_img_name);
      fd.append("city_stiker", carinspectiondata.citySticker);
      fd.append("inspectionnote", carinspectiondata.inspectionnote);
      if (carinspectiondata.hasCitySticker === "yes") {
        if (!carinspectiondata.citySticker) {
          errors.citySticker = "Please select a city sticker";
        }
        if (
          // !carinspectiondata.city_img &&
          carinspectiondata.city_img_name
        ) {
          errors.city_img = "Please upload a city image";
        }
      }

      // Validate ipass image
      // if (
      //   // !carinspectiondata.ipass_img
      //   // carinspectiondata.ipass_img_name
      // ) {
      //   errors.ipass_img = "Please upload an ipass image";
      // }
      fd.append("step_for_maintenance", 5);
      // 🔁 Submit
      await server_post_data(maintainance_car_data, fd)
        .then((Response) => {
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            onNext();
            setCount(6);
          }
          setshowLoaderAdmin(false);
        })
        .catch(() => {
          handleError("network");
          setshowLoaderAdmin(false);
        });
    }
  };

  return (
    <>
      <div className="car-inspections-container">
        {/* Fender Liners */}
        <div className="section">
          <h5>
            Fender Liners / Engine Liners:{" "}
            <span className="mandory_field">*</span>
          </h5>
          {errorMessages.fenderLiners && (
            <span className="error-text">{errorMessages.fenderLiners}</span>
          )}
          <div className="row">
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  carinspectiondata.fenderLiners === "allLinersGood"
                    ? "active goodActive"
                    : ""
                }`}
                onClick={() => handleSelect("fenderLiners", "allLinersGood")}
              >
                All Liners Good
              </button>
            </div>
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  carinspectiondata.fenderLiners === "linersAdjusted"
                    ? "active needBulbActive"
                    : ""
                }`}
                onClick={() => handleSelect("fenderLiners", "linersAdjusted")}
              >
                Liners Adjusted
              </button>
            </div>
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  carinspectiondata.fenderLiners === "linerChanged"
                    ? "active needRepairActive"
                    : ""
                }`}
                onClick={() => handleSelect("fenderLiners", "linerChanged")}
              >
                Liner Changed
              </button>
            </div>
          </div>

          {/* Conditional buttons for linersAdjusted position */}
          {carinspectiondata.fenderLiners === "linersAdjusted" && (
            <div className="mt-3">
              <h6>
                Select Adjusted Position:{" "}
                <span className="mandory_field">*</span>
              </h6>
              {errorMessages.fenderLinersAdjustedPosition && (
                <span className="error-text">
                  {errorMessages.fenderLinersAdjustedPosition}
                </span>
              )}
              <div className="row">
                {[
                  { label: "Left", value: "left" },
                  { label: "Right", value: "right" },
                  { label: "Center", value: "center" },
                ].map(({ label, value }) => (
                  <div className="col-md-4 mb-2" key={value}>
                    <button
                      // className={`btn btn-outline-secondary w-100 ${
                      //   carinspectiondata.fenderLinersAdjustedPosition === value
                      //     ? "active adjustedActive"
                      //     : ""
                      // }`}
                      className={`btn btn-outline-secondary w-100 ${
                        carinspectiondata.fenderLinersAdjustedPosition
                          .split("~@~")
                          .includes(value)
                          ? "active adjustedActive"
                          : ""
                      }`}
                      onClick={() =>
                        handleSelect("fenderLinersAdjustedPosition", value)
                      }
                    >
                      {label}
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="section">
          <div className="d-flex gap-5 align-items-center">
            <h5 className="margin_clssCAr">
              Has City Sticker? <span className="mandory_field">*</span>
            </h5>
            <div className="d-flex align-items-center gap-5">
              <div className="d-flex">
                <input
                  type="radio"
                  className="form-check-input"
                  name="hasCitySticker"
                  value="yes"
                  checked={carinspectiondata.hasCitySticker == "yes"}
                  onChange={() => handleSelect("hasCitySticker", "yes")}
                />
                <label className="form-check-label">Yes</label>
              </div>
              <div className="d-flex align-items-center">
                <input
                  type="radio"
                  className="form-check-input"
                  name="hasCitySticker"
                  value="no"
                  checked={carinspectiondata.hasCitySticker == "no"}
                  onChange={() => handleSelect("hasCitySticker", "no")}
                />
                <label className="form-check-label">No</label>
              </div>
            </div>
          </div>
        </div>
        {/* City Sticker */}
        {carinspectiondata.hasCitySticker === "yes" && (
          <div className="section">
            <h5>
              City Sticker: <span className="mandory_field">*</span>
            </h5>
            {errorMessages.citySticker && (
              <span className="error-text">{errorMessages.citySticker}</span>
            )}
            <div className="row">
              <div className="col-md-3 mb-2">
                <button
                  className={`btn btn-outline-secondary w-100 ${
                    carinspectiondata.citySticker === "mountProspect"
                      ? "active"
                      : ""
                  }`}
                  onClick={() => handleSelect("citySticker", "mountProspect")}
                >
                  Mount Prospect (April)
                </button>
              </div>
              <div className="col-md-3 mb-2">
                <button
                  className={`btn btn-outline-secondary w-100 ${
                    carinspectiondata.citySticker === "parkRidge"
                      ? "active"
                      : ""
                  }`}
                  onClick={() => handleSelect("citySticker", "parkRidge")}
                >
                  Park Ridge (June)
                </button>
              </div>
              <div className="col-md-3 mb-2">
                <button
                  className={`btn btn-outline-secondary w-100 ${
                    carinspectiondata.citySticker === "roselle" ? "active" : ""
                  }`}
                  onClick={() => handleSelect("citySticker", "roselle")}
                >
                  Roselle (September)
                </button>
              </div>
              <div className="col-md-3 mb-2">
                <button
                  className={`btn btn-outline-secondary w-100 ${
                    carinspectiondata.citySticker === "noSticker"
                      ? "active"
                      : ""
                  }`}
                  onClick={() => handleSelect("citySticker", "noSticker")}
                >
                  No Sticker (Come to Office)
                </button>
              </div>
            </div>
          </div>
        )}

        {/* City Sticker Image */}
        {carinspectiondata.hasCitySticker === "yes" && (
          <div className="section">
            <h5>
              Take Picture of the City Sticker:{" "}
              <span className="mandory_field">*</span>
            </h5>
            {errorMessages.city_img && (
              <span className="error-text">{errorMessages.city_img}</span>
            )}
            <div className="col-md-6 mb-2">
              <input
                id="imageInput_city"
                type="file"
                className="form-control custmInput"
                onChange={handleCityImageUpload}
                accept=".png, .jpeg, .jpg, .heic"
              />
              {carinspectiondata.city_img_name && (
                <div className="oil_close_cap_div">
                  <img
                    src={ImageLink + carinspectiondata.city_img_name}
                    alt="City Image Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                    }}
                  />
                  <X
                    className="removeBttn"
                    size={18}
                    onClick={removeCityImage}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        {/* Heating & AC Check */}
        <div className="section">
          <h5>
            Heating & AC Check: <span className="mandory_field">*</span>
          </h5>
          {errorMessages.heatingAC && (
            <span className="error-text">{errorMessages.heatingAC}</span>
          )}
          <div className="row">
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  carinspectiondata.heatingAC === "workingGood"
                    ? "active goodActive"
                    : ""
                }`}
                onClick={() => handleSelect("heatingAC", "workingGood")}
              >
                Working Good
              </button>
            </div>
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  carinspectiondata.heatingAC === "needAttention"
                    ? "active needRepairActive"
                    : ""
                }`}
                onClick={() => handleSelect("heatingAC", "needAttention")}
              >
                Need Attention
              </button>
            </div>
          </div>

          {/* 🆕 Show note field only if "Need Attention" selected */}
          {carinspectiondata.heatingAC === "needAttention" && (
            <div className="mt-2">
              <label className="position-label">
                Heating/AC Note <span className="error-text">*</span>
              </label>
              <textarea
                className="form-control"
                rows="3"
                maxLength={500}
                placeholder="Describe the issue..."
                value={heatingNote}
                onChange={(e) => setHeatingNote(e.target.value)}
              />
              {errorMessages.heatingNote && (
                <span className="error-text">{errorMessages.heatingNote}</span>
              )}
            </div>
          )}
        </div>

        {/* Reset Maintenance */}
        <div className="section">
          <h5>
            Reset Maintenance: <span className="mandory_field">*</span>
          </h5>
          {errorMessages.resetMaintenance && (
            <span className="error-text">{errorMessages.resetMaintenance}</span>
          )}
          <div className="row">
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  carinspectiondata.resetMaintenance === "done"
                    ? "active goodActive"
                    : ""
                }`}
                onClick={() => handleSelect("resetMaintenance", "done")}
              >
                Done
              </button>
            </div>
            <div className="col-md-6 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  carinspectiondata.resetMaintenance === "notDone"
                    ? "active needRepairActive"
                    : ""
                }`}
                onClick={() => handleSelect("resetMaintenance", "notDone")}
              >
                Not Done
              </button>
            </div>
          </div>
        </div>

        {/* Odometer Reading */}
        {/* <div className="section">
          <h5>
            Odometer Reading: <span className="mandory_field">*</span>
          </h5>
          {errorMessages.odometerReading && (
            <span className="error-text">{errorMessages.odometerReading}</span>
          )}
          <input
            className="form-control"
            type="text"
            value={carinspectiondata.odometerReading}
            maxLength={6}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                odometerReading: e.target.value,
              }))
            }
            // onKeyDown={handleNumbersChange}
            onInput={handleNumbersChange}
            placeholder="Odometer Reading"
          />
        </div> */}

        {/* Last 5 Digit Ipass Number */}
        <div className="section">
          <h5>
            Last 5 Digit of iPass Number:{" "}
            <span className="mandory_field">*</span>
          </h5>
          {errorMessages.ipassNumbers && (
            <span className="error-text">{errorMessages.ipassNumbers}</span>
          )}
          <input
            className="form-control"
            type="text"
            maxLength={5}
            value={carinspectiondata.ipassNumbers}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                ipassNumbers: e.target.value,
              }))
            }
            onInput={handleNumbersChange}
            // onKeyDown={handleNumbersChange}
            placeholder="Last 5 Digit of iPass Number"
          />
        </div>

        {/* Upload Ipass Image */}
        <div className="section">
          <h5>
            Upload iPass Image: <span className="mandory_field">*</span>
          </h5>
          {errorMessages.ipass_img && (
            <span className="error-text">{errorMessages.ipass_img}</span>
          )}
          <input
            id="imageInput_ipass"
            type="file"
            className="form-control custmInput"
            onChange={handleIpassImageUpload}
            accept=".png, .jpeg, .jpg, .heic"
          />
          {carinspectiondata.ipass_img_name && (
            <div className="oil_close_cap_div">
              <img
                src={ImageLinkIpass + carinspectiondata.ipass_img_name}
                alt="iPass Image Preview"
                style={{ width: "100px", height: "100px", objectFit: "cover" }}
              />
              <X className="removeBttn" size={18} onClick={removeIpassImage} />
            </div>
          )}
        </div>

        {/* Inspection Notes */}
        <div className="section">
          <h5>Inspection Notes (Optional):</h5>
          <textarea
            className="form-control"
            value={carinspectiondata.inspectionnote}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                inspectionnote: e.target.value,
              }))
            }
            placeholder="Enter inspection notes"
            rows={3}
          />
        </div>

        {/* Navigation Buttons */}
        <div className="navigation-buttons">
          <button
            className="btn back-button"
            onClick={() => {
              onBack();
              setCount(4);
            }}
          >
            Back
          </button>

          <button className="btn next__button" onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    </>
  );
};

export default CarInspections;
